(function () {
    'use strict';

    angular.module("imApp").factory("productUnitsService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductUnits: function (parms) {
                return $ihttp.post({
                    method: 580,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
